/* global ol */
'use strict'

import CloudDataConnector from './api.js'

export default class CensusMapController {
  constructor () {
    this.internal = {
      uiElements: {
        olMap: null,
        searchBar: null,
        loadingContainer: null,
        loadedContainer: null
      },
      searchIndex: [],
      currentSearchTerms: [],
      searchFilteredItems: [],
      selectedItems: [],
      mapVisibleItems: [],
      defaultPageLimit: 5,
      currentPageLimit: 5,
      vectorEquipmentsSource: new ol.source.Vector({}),
      vectorStudiesSource: new ol.source.Vector({})
    }
  }

  wire () {
    if ($('#recenser-container').length > 0) {
      $('#search-btn').on('click', this, this.onAppendSearchTerm)
      $('#search-map-input').on('click', this, this.onCheckedSearchMap)
      $('#loadMoreButton').on('click', this, this.onLoadMoreButtonClicked)
      $('.filter-term-suggestion').on('click', this, this.onfilterTermSuggestionClicked)
      $('#search-bar').on('keydown', this, this.onKeyboardSearchConfirm)
      this.internal.uiElements.loadingContainer = $('#loading-container')
      this.internal.uiElements.loadedContainer = $('#loaded-container')
      this.internal.uiElements.searchBar = $('#search-bar')
    }
    return this
  }

  load () {
    if ($('#recenser-container').length > 0) {
      this.initMap()
      this.initTemplateFormatter()
      this.loadSearchIndex()
      this.computeSearch()
      this.drawMapElements()
      this.updateVisibleItemsList()
      this.drawLeftItems()
    }
  }

  initTemplateFormatter () {
    $.addTemplateFormatter('ListLinkFormatter',
      function (value) {
        return value.split(',').map(val => (`<a href="${val}" target="_blank">${val}</a>`))
      })
  }

  initMap () {
    this.internal.uiElements.olMap = new ol.Map({
      target: 'recenser-map',
      view: new ol.View({ center: ol.proj.fromLonLat([6.90, 45.92]), zoom: 11, maxZoom: 15 }),
      layers: [
        new ol.layer.Tile({
          preload: 3,
          source: new ol.source.OSM({
            crossOrigin: null,
            url: 'https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=851c476fad9743cca9b16af9c72ecc05'
          })
        }),
        new ol.layer.Vector({
          source: this.internal.vectorEquipmentsSource,
          updateWhileAnimating: true,
          updateWhileInteracting: true
        }),
        new ol.layer.Vector({
          source: this.internal.vectorStudiesSource,
          updateWhileAnimating: true,
          updateWhileInteracting: true
        })
      ],
      loadTilesWhileAnimating: true
    })

    // Wire map actions
    const that = this
    this.internal.uiElements.olMap.on('moveend', function (e) {
      that.onMapMoved(e, that)
    })
    this.internal.uiElements.olMap.on('pointermove', function (e) {
      that.onMapPointerMoved(e, that)
    })
    this.internal.uiElements.olMap.on('click', function (e) {
      that.onMapClicked(e, that)
    })
  }

  isEquipmentInRange (equipment) {
    return parseFloat(equipment.latitude) > 45.66 &&
      parseFloat(equipment.latitude) < 46.24 &&
      parseFloat(equipment.longitude) > 6.34 &&
      parseFloat(equipment.longitude) < 7.39
  }

  isStudyInRange (study) {
    return parseFloat(study.latitude) > 45.66 &&
      parseFloat(study.latitude) < 46.24 &&
      parseFloat(study.longitude) > 6.34 &&
      parseFloat(study.longitude) < 7.39
  }

  drawMapElements () {
    let iconImg = null
    let zIndex = null

    this.internal.vectorEquipmentsSource.clear()
    const equipments = this.internal.searchFilteredItems.filter(item => item.apiModel === 'equipment')
    for (const equipment of equipments) {
      // Prepare visuals for map
      const iconFeature = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([parseFloat(equipment.longitude), parseFloat(equipment.latitude)], 'EPSG:4326', 'EPSG:3857')),
        data: equipment
      })
      iconFeature.setId(equipment.id)

      iconImg = '/img/map/equipment-default-optim.png'
      zIndex = 100
      if (this.internal.selectedItems.indexOf(equipment) !== -1) {
        iconImg = '/img/map/equipment-select-default-optim.png'
        zIndex = 300
      }
      const iconStyle = new ol.style.Style({
        image: new ol.style.Icon({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: iconImg,
          crossOrigin: 'anonymous'
        }),
        zIndex
      })
      iconFeature.setStyle(iconStyle)
      this.internal.vectorEquipmentsSource.addFeature(iconFeature)
    }

    this.internal.vectorStudiesSource.clear()
    const studies = this.internal.searchFilteredItems.filter(item => item.apiModel === 'study')
    for (const study of studies) {
      const iconFeature = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([parseFloat(study.longitude), parseFloat(study.latitude)], 'EPSG:4326', 'EPSG:3857')),
        data: study
      })
      iconFeature.setId(study.id_study)

      iconImg = '/img/map/study-default-optim.png'
      zIndex = 100
      if (study.cities.indexOf('Massif du Mont-Blanc') !== -1) {
        if (this.internal.selectedItems.indexOf(study) !== -1) {
          iconImg = '/img/map/study-select-mb-optim.png'
          zIndex = 700
        } else {
          iconImg = '/img/map/study-mb-optim.png'
          zIndex = 500
        }
      } else {
        if (this.internal.selectedItems.indexOf(study) !== -1) {
          iconImg = '/img/map/study-select-default-optim.png'
          zIndex = 300
        }
      }
      // Custom study color when site is "Mont-Blanc"
      const iconStyle = new ol.style.Style({
        image: new ol.style.Icon({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: iconImg,
          crossOrigin: 'anonymous'
        }),
        zIndex
      })
      iconFeature.setStyle(iconStyle)
      this.internal.vectorStudiesSource.addFeature(iconFeature)
    }
  }

  drawLeftItems () {
    // Add cards, according to found elements
    $('#searchResultEquipmentDrawArea').empty()
    $('#searchResultStudyDrawArea').empty()

    const mapVisibleAndSearchFilter = this.internal.mapVisibleItems.filter(item => this.internal.searchFilteredItems.indexOf(item) !== -1)
    const searchResultPage = mapVisibleAndSearchFilter.slice(0, this.internal.currentPageLimit)
    const selectedItemsPage = this.internal.selectedItems.slice(0, this.internal.currentPageLimit)

    // Search results
    const equipmentSearchResults = searchResultPage.filter(item => item.apiModel === 'equipment')
    const studySearchResults = searchResultPage.filter(item => item.apiModel === 'study')
    $('#searchResultEquipmentDrawArea').loadTemplate($('#searchResultEquipmentTemplate'), equipmentSearchResults)
    $('#searchResultStudyDrawArea').loadTemplate($('#searchResultStudyTemplate'), studySearchResults)
    $('#searchTermsDrawArea').loadTemplate($('#searchTermTemplate'), this.internal.currentSearchTerms)

    // Selected items
    const equipmentSelected = selectedItemsPage.filter(item => item.apiModel === 'equipment')
    const studySelected = selectedItemsPage.filter(item => item.apiModel === 'study')
    $('#selectedEquipmentDrawArea').loadTemplate($('#searchResultEquipmentTemplate'), equipmentSelected)
    $('#selectedStudyDrawArea').loadTemplate($('#searchResultStudyTemplate'), studySelected)
    if (selectedItemsPage.length > 0) {
      $('#selectedTitle').removeClass('hidden')
      $('#selectedItemCount').text(`${selectedItemsPage.length} résultat${selectedItemsPage.length > 1 ? 's' : ''}`)
    } else {
      $('#selectedTitle').addClass('hidden')
    }

    if (mapVisibleAndSearchFilter.length <= this.internal.currentPageLimit) {
      $('.seeMoreContainer').addClass('hidden')
    } else {
      $('.seeMoreContainer').removeClass('hidden')
    }

    $('#searchItemCount').text(`${mapVisibleAndSearchFilter.length} résultat${mapVisibleAndSearchFilter.length > 1 ? 's' : ''}`)

    // Wire events
    $('.searchResultExpandButton').on('click', this, this.onToggleBox)
    $('.searchTermCloseButton').on('click', this, this.onRemoveSearchTerm)
    $('#searchResultEquipmentDrawArea .title, #searchResultStudyDrawArea .title').on('click', this, this.onResultItemClicked)
  }

  updateVisibleItemsList () {
    const that = this
    const searchWithMap = document.getElementById('search-map-input').checked
    if (searchWithMap) {
      // Construct list of visible itemp on map
      this.internal.mapVisibleItems = []
      this.internal.currentPageLimit = this.internal.defaultPageLimit
      const extent = this.internal.uiElements.olMap.getView().calculateExtent(this.internal.uiElements.olMap.getSize())
      this.internal.vectorEquipmentsSource.forEachFeatureInExtent(extent, function (feature) {
        const equipment = that.internal.searchIndex.find((v) => {
          return ((v.id === feature.getId()) && (v.apiModel === 'equipment'))
        })
        that.internal.mapVisibleItems.push(equipment)
      })
      this.internal.vectorStudiesSource.forEachFeatureInExtent(extent, function (feature) {
        const study = that.internal.searchIndex.find((v) => {
          return ((v.id_study === feature.getId()) && (v.apiModel === 'study'))
        })
        that.internal.mapVisibleItems.push(study)
      })
    }
  }

  async apiRefresh () {
    return Promise.all([
      new CloudDataConnector().getEquipments(),
      new CloudDataConnector().getStudies()
    ])
  }

  loadSearchIndex () {
    // Use cached data
    if (localStorage.getItem('equipments') && localStorage.getItem('studies')) {
      this.apiDataChanged(JSON.parse(localStorage.getItem('equipments')), JSON.parse(localStorage.getItem('studies')))
      this.apiRefresh()
    } else {
      // Synchronous API loading
      this.internal.uiElements.loadingContainer.removeClass('hidden')
      this.internal.uiElements.loadedContainer.addClass('hidden')
    }

    // In all cases, refresh adata in background
    const that = this
    this.apiRefresh().then(([equipments, studies]) => {
      localStorage.setItem('equipments', JSON.stringify(equipments))
      localStorage.setItem('studies', JSON.stringify(studies))
      that.internal.uiElements.loadingContainer.addClass('hidden')
      that.internal.uiElements.loadedContainer.removeClass('hidden')
      that.apiDataChanged(equipments, studies)
    })
  }

  reformatArrayString (data) {
    let formattedData = data
    if (Array.isArray(data)) {
      formattedData = data.join(', ')
    }
    return formattedData
  }

  apiDataChanged (equipments, studies) {
    for (const equipment of equipments) {
      if (this.isEquipmentInRange(equipment)) {
        const formattedEquipment = equipment
        // Cleanup fields
        if (equipment.active === '') { formattedEquipment.active = 'Non' }
        if (equipment.active === 'True') { formattedEquipment.active = 'Oui' }
        formattedEquipment.organizations_names = this.reformatArrayString(equipment.organizations_names)
        // Setup search index
        this.internal.searchIndex.push({
          ...formattedEquipment,
          apiModel: 'equipment',
          // Additional attributes for search
          custom_type_fr: ['équipement', 'équipements']
        })
      }
    }

    for (const study of studies) {
      if (this.isStudyInRange(study)) {
        const formattedStudy = study
        formattedStudy.authors = this.reformatArrayString(study.authors)
        formattedStudy.organizations_names = this.reformatArrayString(study.organizations_names)
        formattedStudy.websites = this.reformatArrayString(study.websites)
        formattedStudy.cities = this.reformatArrayString(study.cities)
        formattedStudy.thematics = this.reformatArrayString(study.thematics)
        formattedStudy.countries = this.reformatArrayString(study.countries)
        // Setup search index
        this.internal.searchIndex.push({
          ...formattedStudy,
          apiModel: 'study',
          // Additional attributes for search
          custom_type_fr: ['étude', 'études']
        })
      }
    }

    this.computeSearch()
    this.drawMapElements()
    this.updateVisibleItemsList()
    this.drawLeftItems()
  }

  matchArrayAttribute (attributeArray, searchValue) {
    return attributeArray.some(attr => this.matchAttribute(attr, searchValue))
  }

  matchAttribute (attribute, searchValue) {
    if (typeof attribute === 'object' && Array.isArray(attribute)) {
      return this.matchArrayAttribute(attribute, searchValue)
    } else if (typeof attribute === 'string') {
      return attribute.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(searchValue)
    } else if (typeof attribute === 'number') {
      return this.matchAttribute(attribute.toString(), searchValue)
    } else {
      return false
    }
  }

  matchEquipmentStudy (item, searchValue) {
    const equipmentAttributes = ['city', 'country', 'description', 'organizations_names', 'type', 'custom_type_fr', 'date_install']
    const studyAttributes = ['study_name', 'title', 'study_types', 'author', 'date', 'countries', 'cities', 'organizations_names', 'thematics', 'websites', 'custom_type_fr']

    if (item.apiModel === 'equipment') {
      return equipmentAttributes.some(attr => this.matchAttribute(item[attr], searchValue))
    } else if (item.apiModel === 'study') {
      return studyAttributes.some(attr => this.matchAttribute(item[attr], searchValue))
    } else {
      return false
    }
  }

  computeSearch () {
    if (this.internal.currentSearchTerms.length === 0) {
      this.internal.searchFilteredItems = this.internal.searchIndex
      return
    }
    this.internal.selectedItems = []
    this.internal.searchFilteredItems = this.internal.searchIndex
    for (const searchTerm of this.internal.currentSearchTerms) {
      const searchValue = searchTerm.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      this.internal.searchFilteredItems = this.internal.searchFilteredItems.filter(item => this.matchEquipmentStudy(item, searchValue))
    }
  }

  onMapMoved (event, controller) {
    controller.updateVisibleItemsList()
    controller.drawLeftItems()
  }

  onMapPointerMoved (event, controller) {
    const pixel = controller.internal.uiElements.olMap.getEventPixel(event.originalEvent)
    const hit = controller.internal.uiElements.olMap.hasFeatureAtPixel(pixel)
    controller.internal.uiElements.olMap.getViewport().style.cursor = hit ? 'pointer' : ''
  }

  onMapClicked (event, controller) {
    const clickedIconFeature = controller.internal.uiElements.olMap.getFeaturesAtPixel(event.pixel)
    if (clickedIconFeature !== null && clickedIconFeature.length > 0) {
      // There may be a LOT of items because some studies are located at the same place
      // We will mark as "selected" all the corresponding ones
      controller.internal.selectedItems = []
      clickedIconFeature.forEach(item => controller.internal.selectedItems.push(item.values_.data))
      event.preventDefault()
      // Redraw items with selected colors
      controller.drawMapElements()
      controller.drawLeftItems()
    } else {
      controller.internal.selectedItems = []
      controller.drawMapElements()
      controller.drawLeftItems()
    }
  }

  onResultItemClicked (event) {
    const controller = event.data.internal

    const { id, model } = event.currentTarget.dataset
    const idPropName = model === 'equipment' ? 'id' : 'id_study'
    const item = controller.searchIndex.find(item => item.apiModel === model && item[idPropName].toString() === id)
    controller.selectedItems = [item]
    event.data.drawMapElements()
    event.data.drawLeftItems()
  }

  onRemoveSearchTerm (item) {
    item.data.internal.currentSearchTerms = item.data.internal.currentSearchTerms.filter(e => e !== $(item.target).prev().html())
    item.data.computeSearch()
    item.data.drawMapElements()
    item.data.updateVisibleItemsList()
    item.data.drawLeftItems()
  }

  onKeyboardSearchConfirm (item) {
    const keyCode = item.keyCode || item.which
    if (keyCode === 13) item.data.onAppendSearchTerm(item)
  }

  onAppendSearchTerm (item) {
    const term = item.data.internal.uiElements.searchBar.val()
    if (term && item.data.internal.currentSearchTerms.indexOf(term) === -1) {
      item.data.internal.currentSearchTerms.push(term)
      item.data.internal.uiElements.searchBar.val('')
      item.data.computeSearch()
      item.data.drawMapElements()
      item.data.updateVisibleItemsList()
      item.data.drawLeftItems()
    }
  }

  onLoadMoreButtonClicked (item) {
    item.data.internal.currentPageLimit += 5
    item.data.drawLeftItems()
  }

  onfilterTermSuggestionClicked (item) {
    const term = $(item.target).html().trim()
    const termIndex = item.data.internal.currentSearchTerms.indexOf(term)
    if (termIndex === -1) { item.data.internal.currentSearchTerms.push(term) } else { item.data.internal.currentSearchTerms.splice(termIndex, 1) }
    item.data.computeSearch()
    item.data.drawMapElements()
    item.data.updateVisibleItemsList()
    item.data.drawLeftItems()
  }

  onToggleBox (item) {
    let boxToOpen = null
    let toggleIcon = null
    if ($(item.target).prop('tagName') === 'svg') {
      boxToOpen = $(item.target).parent().prev()
      toggleIcon = $(item.target).parent()
    } else {
      boxToOpen = $(item.target).prev()
      toggleIcon = item.target
    }

    if ($(boxToOpen).hasClass('hidden')) {
      $(boxToOpen).removeClass('hidden')
      $(toggleIcon).addClass('rotate180')
    } else {
      $(boxToOpen).addClass('hidden')
      $(toggleIcon).removeClass('rotate180')
    }
  }

  onCheckedSearchMap (item) {
    if (!item.target.checked) {
      item.data.internal.mapVisibleItems = item.data.searchIndex
    } else {
      item.data.internal.mapVisibleItems = []
    }
    $('#search-bar').get(0).dispatchEvent(new Event('input'))
  }
}
